import React from 'react';
import { toast } from 'react-toastify';

const AccountTab = ({ installer, stripeCapabilities, qbo, access }) => {
  const handleComingSoon = (feature) => {
    toast.info(`${feature} coming soon.`);
  };

  return (
    <>
      {/* Account Status */}
      <div className="card mb-4">
        <div className="card-header">
          <h4 className="mb-0">
            <i className="fa-sharp fa-regular fa-user-circle mr-2"></i>
            Account Status
          </h4>
        </div>
        <div className="card-body">
          {installer && (
            <div className="row">
              <div className="col-md-3 mb-3">
                <strong>Account Type</strong><br />
                <span className={`badge ${installer.is_trial ? 'badge-warning' : 'badge-success'}`}>
                  {installer.is_trial ? 'Trial Specialist' : 'Active Specialist'}
                </span>
              </div>
              <div className="col-md-3 mb-3">
                <strong>Subscription</strong><br />
                {installer.subscription || 'ASSIST'}
              </div>
              <div className="col-md-3 mb-3">
                <strong>Payment Status</strong><br />
                <span className={`badge ${installer.onboarding_complete ? 'badge-success' : 'badge-warning'}`}>
                  {installer.onboarding_complete ? 'Setup Complete' : 'Setup Required'}
                </span>
                {installer.onboarding_complete && stripeCapabilities &&
                  Object.keys(stripeCapabilities).length > 0 &&
                  stripeCapabilities.us_bank_account_ach_payments !== 'active' && (
                  <div className="mt-1">
                    <span className="badge badge-warning">
                      <i className="fa-sharp fa-regular fa-exclamation-triangle mr-1"></i> Capabilities Pending
                    </span>
                  </div>
                )}
              </div>
              <div className="col-md-3 mb-3">
                <strong>Member Since</strong><br />
                {installer.created_at ? new Date(installer.created_at).toLocaleDateString('en-US', { month: 'short', year: 'numeric' }) : 'N/A'}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Subscription (placeholder) */}
      <div className="card mb-4">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h4 className="mb-0">
            <i className="fa-sharp fa-regular fa-crown mr-2"></i>
            Subscription
          </h4>
          <button className="btn btn-outline-primary btn-sm" onClick={() => handleComingSoon('Plan management')}>
            Manage Plan
          </button>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <h5 className="mb-1">{installer?.subscription || 'ASSIST'} Plan</h5>
              <p className="text-muted mb-3">Your current subscription plan</p>
              <div className="mb-2">
                <strong>Next Invoice:</strong> <span className="text-muted">—</span>
              </div>
            </div>
            <div className="col-md-6">
              <h6 className="mb-2">Plan Features</h6>
              <ul className="list-unstyled text-muted small">
                <li className="mb-1"><i className="fa-sharp fa-regular fa-check text-success mr-2"></i>Unlimited jobs</li>
                <li className="mb-1"><i className="fa-sharp fa-regular fa-check text-success mr-2"></i>AI Estimate page</li>
                <li className="mb-1"><i className="fa-sharp fa-regular fa-check text-success mr-2"></i>Payment processing</li>
                <li className="mb-1"><i className="fa-sharp fa-regular fa-check text-success mr-2"></i>Calendar sync</li>
              </ul>
            </div>
          </div>
          <p className="text-muted small mb-0">
            <i className="fa-sharp fa-regular fa-info-circle mr-1"></i>
            Subscription management coming soon.
          </p>
        </div>
      </div>

      {/* Need Help */}
      <div className="card mb-4">
        <div className="card-header">
          <h4 className="mb-0">
            <i className="fa-sharp fa-regular fa-life-ring mr-2"></i>
            Need Help?
          </h4>
        </div>
        <div className="card-body">
          <p>Having trouble with setup or have questions?</p>
          <div className="d-flex flex-wrap">
            <a href="mailto:support@jobvious.com" className="btn btn-outline-primary btn-sm mr-2 mb-2">
              <i className="fa-sharp fa-regular fa-envelope mr-1"></i> Contact Support
            </a>
            <button className="btn btn-outline-secondary btn-sm mr-2 mb-2" onClick={() => handleComingSoon('Help Center')}>
              <i className="fa-sharp fa-regular fa-book mr-1"></i> Help Center
            </button>
            <button className="btn btn-outline-secondary btn-sm mb-2" onClick={() => handleComingSoon('Tutorials')}>
              <i className="fa-sharp fa-regular fa-video mr-1"></i> Tutorials
            </button>
          </div>
        </div>
      </div>

    </>
  );
};

export default AccountTab;
